import {nil} from "felles-ng2/typer/nullish";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";

/** Returnerer en {@link FormData} instans for bruk ifbm opplasting av fil.
 * Merk at vi sender filnavnet som eget FormData parameter ('filnavn') da filnavnet
 * sendt som del av 'fil' parameteret ikke blir enkodet med UTF-8, men tilsynelatende ISO-88951, dog
 * er jeg (kai) usikker på om den samme enkoding benyttes av alle nettlesere. Standarden virker litt uklar
 * på dette punktet.*/
export function formDataMedFil(fil: File): FormData {
    const data = new FormData();
    data.append('fil', fil, fil.name);
    data.append('filnavn', fil.name);
    return data;
}

export function eventStopOgPrevent(event: Event) {
    event.stopPropagation();
    event.preventDefault();
}

export function fileListSomArray(filer: FileList | nil): File[] {
    if (erNil(filer) || filer.length == 0) return [];
    const filArray: File[] = [];
    for (let i = 0; i < filer.length; i++) filArray.push(filer[i]);
    return filArray;
}

export function erTouchEvent(event: UIEvent): event is TouchEvent {
    return ('touches' in event);
}

/** Finn første node fra angitt node og oppover foreldrekjeden som har nodeName lik angitt nodeName */
export function finnNodensNærmesteForelderAvType(element: Node, nodeName: string): Node | null {
    return finnNærmesteForelderNodeSomMatcher(element, element => element.nodeName.toLowerCase() === nodeName.toLowerCase());
}

/** Finn første element fra angitt element og oppover foreldrekjeden som har tagName lik angitt tagNavn */
export function finnElementetsNærmesteForelderAvType(element: HTMLElement, tagNavn: string): HTMLElement | null {
    return finnNærmesteForelderElementSomMatcher(element, element => element.tagName.toLowerCase() === tagNavn.toLowerCase());
}

/** Finn første element fra og med angitt element og oppover foreldrekjeden som angitt match metode returnerer sann for  */
export function finnNærmesteForelderElementSomMatcher(element: HTMLElement, match: (element: HTMLElement) => boolean): HTMLElement | null {
    let kandidat: HTMLElement | null = element;
    while (erIkkeNil(kandidat)) {
        if (match(kandidat)) return kandidat;
        kandidat = kandidat.parentElement;
    }
    return null;
}

/** Finn første node fra og med angitt node og oppover foreldrekjeden som angitt match metode returnerer sann for  */
export function finnNærmesteForelderNodeSomMatcher(node: Node, match: (element: Node) => boolean): Node | null {
    let kandidat: Node | null = node;
    while (erIkkeNil(kandidat)) {
        if (match(kandidat)) return kandidat;
        kandidat = kandidat.parentNode;
    }
    return null;
}

/** Sann dersom angitt node er barn av angitt forelder */
export function erBarnAv(node: Node | nil, forelder: Node | nil): boolean {
    if (erNil(node) || erNil(forelder)) return false;
    let kandidat: Node | null = node;
    while (erIkkeNil(kandidat) && kandidat.parentNode !== forelder)
        kandidat = kandidat.parentNode;

    return erIkkeNil(kandidat);
}
